export const customer_area_setting = {
  customer_tenant_activated_on_web: {
    fieldPath: 'customer_tenant_activated_on_web',
    fieldReadPath: 'customer_tenant_activated_on_web',
    name: 'customer_tenant_activated_on_web',
    label: 'core.customer_tenant_activated_on_web.label',
    help: 'core.customer_tenant_activated_on_web.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_activated_on_app: {
    fieldPath: 'customer_tenant_activated_on_app',
    fieldReadPath: 'customer_tenant_activated_on_app',
    name: 'customer_tenant_activated_on_app',
    label: 'core.customer_tenant_activated_on_app.label',
    help: 'core.customer_tenant_activated_on_app.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_show_in_global_app: {
    fieldPath: 'customer_tenant_show_in_global_app',
    fieldReadPath: 'customer_tenant_show_in_global_app',
    name: 'customer_tenant_show_in_global_app',
    label: 'core.customer_tenant_show_in_global_app.label',
    help: 'core.customer_tenant_show_in_global_app.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_show_in_custom_app: {
    fieldPath: 'customer_tenant_show_in_custom_app',
    fieldReadPath: 'customer_tenant_show_in_custom_app',
    name: 'customer_tenant_show_in_custom_app',
    label: 'core.customer_tenant_show_in_custom_app.label',
    help: 'core.customer_tenant_show_in_custom_app.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_custom_app_name: {
    fieldPath: 'customer_tenant_custom_app_name',
    fieldReadPath: 'customer_tenant_custom_app_name',
    name: 'customer_tenant_custom_app_name',
    label: 'core.customer_tenant_custom_app_name.label',
    help: 'core.customer_tenant_custom_app_name.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_individual_product_bookings_activated: {
    fieldPath: 'customer_individual_product_bookings_activated',
    fieldReadPath: 'customer_individual_product_bookings_activated',
    name: 'customer_individual_product_bookings_activated',
    label: 'core.customer_individual_product_bookings_activated.label',
    help: 'core.customer_individual_product_bookings_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_individual_product_booking_requests_activated: {
    fieldPath: 'customer_individual_product_booking_requests_activated',
    fieldReadPath: 'customer_individual_product_booking_requests_activated',
    name: 'customer_individual_product_booking_requests_activated',
    label: 'core.customer_individual_product_booking_requests_activated.label',
    help: 'core.customer_individual_product_booking_requests_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_individual_product_activity_camps_activated: {
    fieldPath: 'customer_individual_product_activity_camps_activated',
    fieldReadPath: 'customer_individual_product_activity_camps_activated',
    name: 'customer_individual_product_activity_camps_activated',
    label: 'core.customer_individual_product_activity_camps_activated.label',
    help: 'core.customer_individual_product_activity_camps_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
  },

  customer_individual_product_activity_courses_activated: {
    fieldPath: 'customer_individual_product_activity_courses_activated',
    fieldReadPath: 'customer_individual_product_activity_courses_activated',
    name: 'customer_individual_product_activity_courses_activated',
    label: 'core.customer_individual_product_activity_courses_activated.label',
    help: 'core.customer_individual_product_activity_courses_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  customer_individual_product_activity_sessions_activated: {
    fieldPath: 'customer_individual_product_activity_sessions_activated',
    fieldReadPath: 'customer_individual_product_activity_sessions_activated',
    name: 'customer_individual_product_activity_sessions_activated',
    label: 'core.customer_individual_product_activity_sessions_activated.label',
    help: 'core.customer_individual_product_activity_sessions_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  customer_individual_product_subscriptions_activated: {
    fieldPath: 'customer_individual_product_subscriptions_activated',
    fieldReadPath: 'customer_individual_product_subscriptions_activated',
    name: 'customer_individual_product_subscriptions_activated',
    label: 'core.customer_individual_product_subscriptions_activated.label',
    help: 'core.customer_individual_product_subscriptions_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_individual_product_entries_activated: {
    fieldPath: 'customer_individual_product_entries_activated',
    fieldReadPath: 'customer_individual_product_entries_activated',
    name: 'customer_individual_product_entries_activated',
    label: 'core.customer_individual_product_entries_activated.label',
    help: 'core.customer_individual_product_entries_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_organization_product_booking_requests_activated: {
    fieldPath: 'customer_organization_product_booking_requests_activated',
    fieldReadPath: 'customer_organization_product_booking_requests_activated',
    name: 'customer_organization_product_booking_requests_activated',
    label: 'core.customer_organization_product_booking_requests_activated.label',
    help: 'core.customer_organization_product_booking_requests_activated.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  customer_tenant_favicon: {
    fieldPath: 'customer_tenant_favicon',
    fieldReadPath: 'customer_tenant_favicon',
    name: 'customer_tenant_favicon',
    label: 'core.customer_tenant_favicon.label',
    help: 'core.customer_tenant_favicon.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_short_name: {
    fieldPath: 'customer_tenant_short_name',
    fieldReadPath: 'customer_tenant_short_name',
    name: 'customer_tenant_short_name',
    label: 'core.customer_tenant_short_name.label',
    help: 'core.customer_tenant_short_name.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_logo: {
    fieldPath: 'customer_tenant_logo',
    fieldReadPath: 'customer_tenant_logo',
    name: 'customer_tenant_logo',
    label: 'core.customer_tenant_logo.label',
    help: 'core.customer_tenant_logo.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_intro_text: {
    fieldPath: 'customer_tenant_intro_text',
    fieldReadPath: 'customer_tenant_intro_text',
    name: 'customer_tenant_intro_text',
    label: 'core.customer_tenant_intro_text.label',
    help: 'core.customer_tenant_intro_text.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_intro_img: {
    fieldPath: 'customer_tenant_intro_img',
    fieldReadPath: 'customer_tenant_intro_img',
    name: 'customer_tenant_intro_img',
    label: 'core.customer_tenant_intro_img.label',
    help: 'core.customer_tenant_intro_img.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_info_text: {
    fieldPath: 'customer_tenant_info_text',
    fieldReadPath: 'customer_tenant_info_text',
    name: 'customer_tenant_info_text',
    label: 'core.customer_tenant_info_text.label',
    help: 'core.customer_tenant_info_text.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_schedules_text: {
    fieldPath: 'customer_tenant_schedules_text',
    fieldReadPath: 'customer_tenant_schedules_text',
    name: 'customer_tenant_schedules_text',
    label: 'core.customer_tenant_schedules_text.label',
    help: 'core.customer_tenant_schedules_text.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
    fieldAttributes: {
      rows: 8,
    },
  },
  customer_tenant_main_address: {
    fieldPath: 'customer_tenant_main_address',
    fieldReadPath: 'customer_tenant_main_address',
    name: 'customer_tenant_main_address',
    label: 'core.customer_tenant_main_address.label',
    help: 'core.customer_tenant_main_address.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_main_phone: {
    fieldPath: 'customer_tenant_main_phone',
    fieldReadPath: 'customer_tenant_main_phone',
    name: 'customer_tenant_main_phone',
    label: 'core.customer_tenant_main_phone.label',
    help: 'core.customer_tenant_main_phone.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_main_email: {
    fieldPath: 'customer_tenant_main_email',
    fieldReadPath: 'customer_tenant_main_email',
    name: 'customer_tenant_main_email',
    label: 'core.customer_tenant_main_email.label',
    help: 'core.customer_tenant_main_email.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_home_sections_intro_text: {
    fieldPath: 'customer_tenant_home_sections_intro_text',
    fieldReadPath: 'customer_tenant_home_sections_intro_text',
    name: 'customer_tenant_home_sections_intro_text',
    label: 'core.customer_tenant_home_sections_intro_text.label',
    help: 'core.customer_tenant_home_sections_intro_text.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_tenant_home_account_intro_text: {
    fieldPath: 'customer_tenant_home_account_intro_text',
    fieldReadPath: 'customer_tenant_home_account_intro_text',
    name: 'customer_tenant_home_account_intro_text',
    label: 'core.customer_tenant_home_account_intro_text.label',
    help: 'core.customer_tenant_home_account_intro_text.help',
    helpMode: 'displayed_below',
    options: [],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_birthdate: {
    fieldPath: 'customer_contact_manage_birthdate',
    fieldReadPath: 'customer_contact_manage_birthdate',
    name: 'customer_contact_manage_birthdate',
    label: 'core.customer_contact_manage_birthdate.label',
    help: 'core.customer_contact_manage_birthdate.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_gender: {
    fieldPath: 'customer_contact_manage_gender',
    fieldReadPath: 'customer_contact_manage_gender',
    name: 'customer_contact_manage_gender',
    label: 'core.customer_contact_manage_gender.label',
    help: 'core.customer_contact_manage_gender.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_address: {
    fieldPath: 'customer_contact_manage_address',
    fieldReadPath: 'customer_contact_manage_address',
    name: 'customer_contact_manage_address',
    label: 'core.customer_contact_manage_address.label',
    help: 'core.customer_contact_manage_address.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_phone: {
    fieldPath: 'customer_contact_manage_phone',
    fieldReadPath: 'customer_contact_manage_phone',
    name: 'customer_contact_manage_phone',
    label: 'core.customer_contact_manage_phone.label',
    help: 'core.customer_contact_manage_phone.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_phone2: {
    fieldPath: 'customer_contact_manage_phone2',
    fieldReadPath: 'customer_contact_manage_phone2',
    name: 'customer_contact_manage_phone2',
    label: 'core.customer_contact_manage_phone2.label',
    help: 'core.customer_contact_manage_phone2.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_email2: {
    fieldPath: 'customer_contact_manage_email2',
    fieldReadPath: 'customer_contact_manage_email2',
    name: 'customer_contact_manage_email2',
    label: 'core.customer_contact_manage_email2.label',
    help: 'core.customer_contact_manage_email2.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_id_card_number: {
    fieldPath: 'customer_contact_manage_id_card_number',
    fieldReadPath: 'customer_contact_manage_id_card_number',
    name: 'customer_contact_manage_id_card_number',
    label: 'core.customer_contact_manage_id_card_number.label',
    help: 'core.customer_contact_manage_id_card_number.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_passport_number: {
    fieldPath: 'customer_contact_manage_passport_number',
    fieldReadPath: 'customer_contact_manage_passport_number',
    name: 'customer_contact_manage_passport_number',
    label: 'core.customer_contact_manage_passport_number.label',
    help: 'core.customer_contact_manage_passport_number.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_registration_number: {
    fieldPath: 'customer_contact_manage_registration_number',
    fieldReadPath: 'customer_contact_manage_registration_number',
    name: 'customer_contact_manage_registration_number',
    label: 'core.customer_contact_manage_registration_number.label',
    help: 'core.customer_contact_manage_registration_number.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_external_reference: {
    fieldPath: 'customer_contact_manage_external_reference',
    fieldReadPath: 'customer_contact_manage_external_reference',
    name: 'customer_contact_manage_external_reference',
    label: 'core.customer_contact_manage_external_reference.label',
    help: 'core.customer_contact_manage_external_reference.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_language: {
    fieldPath: 'customer_contact_manage_language',
    fieldReadPath: 'customer_contact_manage_language',
    name: 'customer_contact_manage_language',
    label: 'core.customer_contact_manage_language.label',
    help: 'core.customer_contact_manage_language.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_nationality: {
    fieldPath: 'customer_contact_manage_nationality',
    fieldReadPath: 'customer_contact_manage_nationality',
    name: 'customer_contact_manage_nationality',
    label: 'core.customer_contact_manage_nationality.label',
    help: 'core.customer_contact_manage_nationality.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
  customer_contact_manage_health_information: {
    fieldPath: 'customer_contact_manage_health_information',
    fieldReadPath: 'customer_contact_manage_health_information',
    name: 'customer_contact_manage_health_information',
    label: 'core.customer_contact_manage_health_information.label',
    help: 'core.customer_contact_manage_health_information.help',
    helpMode: 'displayed_below',
    options: [
      { text: 'global.show_register_field.no_display', value: 'no_display' },
      { text: 'global.show_register_field.display_not_mandatory', value: 'display_not_mandatory' },
      { text: 'global.show_register_field.display_mandatory', value: 'display_mandatory' },
    ],
    veeValidation: true,
    rules: [],
  },
};
